const NameShape = new Set([
  'name',
  'Name',
  'region',
  'admu_name',
  'forestname',
  'unit',
  'assemblydi',
  'rrk_region',
  'namelsad',
  'OBJECTID',
  'UUID',
]);
const BoundariesMap = [
  {
    label: 'BLM CA Administrative Unit Boundary Field Office Polygon',
    value: {
      name: 'boundary:blm_ca_administrative_unit_boundary_field_office_polygon',
      label: 'admu_name',
    },
  },
  {
    label: 'Administrative Forest Boundaries',
    value: {
      name: 'boundary:forest_administrative_boundaries',
      label: 'forestname',
    },
  },
  {
    label: 'CAL FIRE Operational Units',
    value: { name: 'boundary:cal_fire_operational_units', label: 'unit' },
  },
  {
    label: 'California State Senate Districts',
    value: {
      name: 'boundary:california_state_senate_districts_map_2020',
      label: 'name',
    },
  },
  {
    label: 'California Assembly Districts',
    value: { name: 'boundary:assembly_districts', label: 'assemblydi' },
  },
  {
    label: 'Regional Resource Kit Boundaries',
    value: { name: 'boundary:rrk_boundaries', label: 'rrk_region' },
  },
  {
    label: 'California Local Fire Districts',
    value: {
      name: 'boundary:california_local_fire_districts',
      label: 'name',
    },
  },
  {
    label: 'California Counties',
    value: { name: 'boundary:ca_counties', label: 'namelsad' },
  },
  {
    label:
      'California Wildfire & Forest Resilience Task Force Region Boundaries',
    value: {
      name: 'boundary:wftf_regions_final_updated_july_2025',
      label: 'region',
    },
  },
];
export { NameShape, BoundariesMap };
